import { Image } from '@/app/_components/common/Image';
import { Link } from '@/app_components/common/Link';
import { ButtonRight } from '@/app_components/icons/buttons/ButtonRight';
import { RatingComponent } from '@/app_components/NDR/Rating';
import type { Review } from '@/app_data/mock/ndrData';
import { trackGtmEvent } from '@/app_lib/utils/ndrUtils';

interface NdrStickyBannerProps {
  review: Review;
  queryParams?: string;
}

export const NdrStickyBanner = ({ review, queryParams = '' }: NdrStickyBannerProps) => {
  const telLink = `tel:${review.companyPhone || ''}`;

  return (
    <div className='flex flex-col items-center p-6 gap-10 bg-blue-50'>
      <Image
        alt='NDR company logo'
        data-cy='ndr-company-card-logo'
        fullWidth={false}
        height={60}
        priority
        src={review.companyLogos.reviewCard || ''}
        width={100}
      />
      <div className='flex flex-col items-center gap-6 w-full'>
        <RatingComponent
          rating={review.reviewScore}
          reviewLabel={review.reviewLabel}
          size='stickyBanner'
        />
        <div className='w-full font-graphik-compact flex flex-col items-center gap-2'>
          <Link
            className='flex justify-center items-center gap-2 px-8 py-4 w-full rounded-full bg-blue-600 text-white text-base font-medium leading-4'
            href={`${review.ctas.sticky.url}?${queryParams}`}
            onClick={() => {
              trackGtmEvent(`${review.ctas.sticky.url}?${queryParams}`);
            }}
          >
            {review.ctas.sticky.text}
            <ButtonRight className='mt-0.5' />
          </Link>
          <div className='px-4 mb-4 text-primary text-center typography-sm font-normal'>
            Visit the {review.companyName} website
            {review.companyPhone && (
              <>
                &nbsp; or call:
                <Link
                  className='ml-0.5 whitespace-nowrap underline text-blue-500'
                  href={telLink}
                  onClick={() => {
                    trackGtmEvent(telLink);
                  }}
                >
                  {review.companyPhone}
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
